module.exports = __webpack_public_path__ + "img/skating006.c88fb9f9.jpg";